module.exports = __webpack_public_path__ + "img/logoblack.d916c3fc.png";